export default class Person {
    constructor(firstName = '',
                phoneNumberPrefix = '',
                phoneNumber = '',
                lastName = '',
                email = '',
                birthDate = '',
                lastFour = '',
                tickets = [],
    ) {
        this.firstName = firstName;
        this.phoneNumberPrefix = phoneNumberPrefix;
        this.phoneNumber = phoneNumber;
        this.lastName = lastName;
        this.email = email;
        this.birthDate = birthDate;
        this.lastFour = lastFour;
        this.tickets = tickets;
    }
}